// extracted by mini-css-extract-plugin
export default {"div":"Orderer_div__w6eSE","input":"Orderer_input__p9Sz9","span":"Orderer_span__62BlZ","button":"Orderer_button__XulpR","a":"Orderer_a__yzUze"};